
const baseAdvertUrl = "Advert"
const baseUserUrl = "User"
  const endpoints = {
   getAlarmList:`${baseUserUrl}/GetUserAlarmList`,
   cancelAlarmItem:`${baseAdvertUrl}/DeleteAlarmListByAdvert`
  };
  
  export default endpoints;